<template>
  <v-container fluid>
    <v-layout justify-start>
      <v-card width="100%" >
        <v-flex lg12 pa-5 >
          <v-layout>
            <v-layout>
              <v-flex >
                <h2 class="primary--text text-uppercase">
                  {{localization.list.title}}
                </h2>
              </v-flex>
            </v-layout>
            <v-layout wrap align-center justify-end pb-4>
              <v-flex xs8 sm8 md8 lg8 justify-end class="text-end">
                <v-btn
                  style="margin-right: 10px"
                  color="primary" 
                  @click="dialogImportar = true"
                  v-if="tubos"
                >
                  IMPORTAR
                </v-btn>
                <v-btn 
                  style="margin-right: 10px"
                  color="primary"
                  @click="crearOperacion = true"
                  :disabled="operacionSelectedId ? true : false"   
                >
                  {{localization.selectItems.addButton}}
                </v-btn>
                <v-btn   
                  color="primary"
                  @click="editarOperacion = true"
                  :disabled="operacionSelectedId ? false : true"   
                >
                  {{localization.selectItems.editarButton}}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout wrap justify-end>
            <v-flex xs3 sm3 md3 lg3 mb-4 mt-n4>
                <v-autocomplete
                  style="margin-right: 20px"
                  clearable
                  v-model="promoSelected" id="promoSelected"
                  :items="promociones"
                  item-value="id"
                  item-text="nombreCompleto"
                  label="Filtrar promociones"
                />
            </v-flex>
            <v-flex xs3 sm3 md3 lg3 mb-4 mt-n4>
              <v-text-field
                v-model="search" id="search"
                append-icon="mdi-magnify"
                label="Filtrar"
                hide-details></v-text-field>
            </v-flex>  
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="operaciones"
            sort-by="nombrePromocion"
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" @click="selectItem(item)" :style="{'background-color': operacionSelectedId === item.id ? 'lightgray' : ''}">
                  <td class="text-xs-left">{{ item.code }}</td>
                  <td class="text-xs-left">{{ item.nombrePromocion }}</td>
                  <td class="text-xs-left" style="position: relative">
                    <v-avatar
                      color="primary lighten-2"
                      style="position:absolute; left: -20px; top:5px; color: white; font-size: 10px"
                      size="20"  
                    >
                      {{item.inmueblesIds.length}}
                    </v-avatar> 
                    <p v-for="item in item.inmueblesIds" :key="item">{{ getInmuebleName(item) }}</p>
                  </td>
                  <td class="text-xs-left">{{ item.nombreCliente }}</td>
                  <td class="text-xs-left">{{ item.nombreAmbito }}</td>
                  <td class="text-xs-center">
                    <v-flex row justify-center>
                      <v-icon class="iconSize" small @click="openDelete(item.code)">delete</v-icon>
                    </v-flex>
                  </td>
                </tr>
              </tbody>
              <ConfirmDialog @close="deleteItem()" :text="textDialog"
                @cancel="dialog = false" :dialogFlag="dialog" />
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
      <FormImportar v-model="dialogImportar" id="dialogImportar" v-if="dialogImportar" :tipo="'operaciones'" @reload="refrescarImportar()" @input="refrescarImportar()"/>
    </v-layout>
    <v-fade-transition>
      <custom-dialog
        v-if="crearOperacion === true" 
        v-model="crearOperacion" 
        id="crearOperacion"
      >
        <PopUpNuevaOperacion
          @aceptar="addOperacion($event)"         
          :editar="false"
          :item="promoFilter"
        />
      </custom-dialog>
      <custom-dialog
        v-if="editarOperacion === true && crearOperacion === false" 
        v-model="editarOperacion" 
        id="editarOperacion"
      >
        <PopUpSeleccionarInmueblesRolAdmin 
          @selected="addOperacion($event)"         
          :multiple="true"
          :yaSeleccionado="operacionPopUpEditar.inmueblesIds"
          :promoId="operacionPopUpEditar.promocionId"
          :operacion="true"
          :editar="editarOperacion"
          :operacionAEditar="operacionPopUpEditar"
        />
      </custom-dialog>
    </v-fade-transition>
    
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '../../custom/confirmDialog'
import PopUpNuevaOperacion from './PopUpNuevaOperacion'
import PopUpSeleccionarInmueblesRolAdmin from '../../incidencias/PopUpSeleccionarInmueblesRolAdmin.vue'
import FormImportar from '../../incidencias/formularios/gestion/formImportarOperaciones'

export default {
  components: {
    ConfirmDialog,
    PopUpNuevaOperacion,
    PopUpSeleccionarInmueblesRolAdmin,
    FormImportar
  },
  data () {
    return {
      search: '',
      operacionSelectedId: null,
      dialog: false,
      itemToDeleteId: null,
      textDialog: null,
      operacionPopUpEditar: {},
      crearOperacion: false,
      editarOperacion: false,
      promoSelected: null,
      promoFilter: null,
      dialogImportar: false,
      tubos: true,
      operaciones: []
    }
  },
  computed: {
    ...mapGetters({
      /* tubos: 'getTubos' */
    }),
    localization () {
      return this.$t('gestion.operaciones')
    },
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
        { text: this.localization.list.promocion, value: 'nombrePromoción', sortable: true, align: 'left' },
        { text: this.localization.list.inmueble, value: 'nombreInmueble', sortable: true, align: 'left' },
        /* { sortable: true, align: 'left', width: '5px' }, */
        { text: this.localization.list.cliente, value: 'nombreCliente', sortable: true, align: 'left' },
        { text: this.localization.list.ambito, value: 'nombreAmbito', sortable: true, align: 'left' },
        { text: '', value: '', align: 'center' }
      ]
    },
    promociones() {
      if (this.$store.state.gestion.promotions) {
        return this.$store.state.gestion.promotions.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    inmuebles (){
       if (this.$store.state.gestion.properties) {
        if(this.promoSelected == null ){
          return this.$store.state.gestion.properties
        }
        else{
          const filtroInmuebles = this.$store.state.gestion.properties
          return filtroInmuebles.filter(x => {return x.promocionId === this.promoSelected 
          })
        }
      }
      return null
    },
    
    seccion(){
      if(this.$store.state.gestion.componenteSeleccionado){
        return this.$store.state.gestion.componenteSeleccionado
      }
      return ''
    }
  },
  mounted () {
  },
  async created(){
    this.loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
    })
    await this.getOperaciones()
    await this.getInmuebles()
    await this.getPromotions()
    await this.getClientes()
    this.operaciones = await this.getToShowOperaciones()
    this.loader.hide()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getOperaciones: 'gestion/getOperaciones',
      addOperation: 'gestion/addOperation',
      updateOperation: 'gestion/updateOperation',
      deleteOperation: 'gestion/deleteOperation',
      getInmuebles: 'gestion/getInmuebles',
      getPromotions: 'gestion/getPromotions',
      getClientes: 'gestion/getClientes'
    }),


    getToShowOperaciones(){
      if (this.$store.state.gestion.operations) {
        let operacionesSinFiltrar = this.$store.state.gestion.operations
        let result = operacionesSinFiltrar.reduce((unique, o) => {
          if(!unique.some(obj => obj.clienteId === o.clienteId && obj.code === o.code && obj.promocionId === o.promocionId && obj.ambitoOperacionId === o.ambitoOperacionId) ) {
            o.inmueblesIds = [o.inmuebleId]
            unique.push(o);
          } else {
            unique.find(x=> x.code === o.code).inmueblesIds.push(o.inmuebleId)
          }
          
          return unique.map(x => {
            return {
              ...x,
              nombrePromocion: this.promociones.find(y => y.id === x.promocionId) ? this.promociones.find(y => y.id === x.promocionId).nombreCompleto : null
              }
            })
          },[]) 
        if(this.promoSelected == null){
          return result
        }
        else{
          return result.filter(x => {return x.promocionId == this.promoSelected})
        }
      }
      return []
    },
    getInmuebleName(id){
      let nombres= this.inmuebles.find(x => x.id === id)
      return nombres ? nombres.uhedit : null
    },
    async openDelete (code) {
      this.textDialog = '¿Está seguro que desea eliminar el elemento seleccionado?'
      this.openDialog(code)
    },
    selectItem (item) {
      if (!this.operacionSelectedId || this.operacionSelectedId !== item.id) {
        this.operacionSelectedId = item.id
      } else {
        if(!this.dialog){
          this.operacionSelectedId = null
        }
        
      }
    },
    async addOperacion (ev) {
      this.loader = this.$loading.show({       
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
      })
      try {
        if(this.operacionSelectedId != null)
        {
          ev.editar = true
        }
        await this.addOperation(ev)
        await this.getOperaciones()
        this.operaciones = await this.getToShowOperaciones()
        this.loader.hide()
        this.addAlert({texto: this.$t('alta_correcta'), color: 'success'})
        if(this.operacionSelectedId != null){
          this.operacionPopUpEditar = this.operaciones.find(x=> x.id === this.operacionSelectedId)
          await this.updateOperation(ev)
        }
      } catch (error) {
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    openDialog (itemCode) {
      this.dialog = true
      this.itemToDeleteId = itemCode
    },
    async deleteItem () {
      this.dialog = false
      this.loader = this.$loading.show({       
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
      })
      try{
        await this.deleteOperation(this.itemToDeleteId)
        this.operacionSelectedId = null
        await this.getOperaciones()
        this.operaciones = await this.getToShowOperaciones()
        this.addAlert({texto: this.$t('baja_correcta'), color: 'success'})
      } catch(e) {
        return e
      }
      this.loader.hide()
    },
     async refrescarImportar(){
      await this.getOperaciones()
      await this.getInmuebles()
      await this.getPromotions()
      await this.getClientes()
      this.operaciones = await this.getToShowOperaciones()
    }
  },
  watch: {
    operacionSelectedId () {
      this.operacionPopUpEditar = this.operaciones.find(x=> x.id === this.operacionSelectedId)
    },
    async promoSelected() {
      this.operaciones = await this.getToShowOperaciones()
      if(this.promoSelected != null){this.promoFilter = {promocionId: this.promoSelected}}else{this.promoFilter= null} 
      this.operacionSelectedId=null  
    },
    seccion (){
      this.operacionSelectedId = null
      this.search = ''
      this.promoSelected = null
    }
  }
}
</script>

